module.exports = __webpack_public_path__ + "img/pdf.dae126b8.svg";